export default __webpack_public_path__ + "static/media/branch-management.317a0993.png";